export default {
  props: {
    productInfoManager: {
      type: Object,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    saveImmediately: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localValue: '',
      isUpdating: false,
      hasError: false,
      showSuccess: false,
      successTimeout: null,
      validationError: false,
      debouncedUpdate: null
    };
  },
  computed: {
    backendValue() {
      return this.productInfoManager?.getData()?.book?.[this.fieldName];
    }
  },
  mounted() {
    // Initialize from backend
    this.initializeFromBackend();
    
    // Setup ProductInfo event listeners
    this.setupProductInfoListeners();
  },
  beforeDestroy() {
    if (this.successTimeout) clearTimeout(this.successTimeout);
  },
  methods: {
    initializeFromBackend() {
      this.localValue = this.backendValue;
    },
    
    onInput(value) {
      this.validationError = false;
      this.localValue = value;
      const currentValue = this.productInfoManager.getData()?.book?.[this.fieldName];
      let valueToSave = this.localValue;
      
      if (this.productInfoManager) {

        if (this.saveImmediately) {
          this.isUpdating = true;
          if (currentValue == valueToSave) {
            this.isUpdating = false;
          }
        }

        if (!this.debouncedUpdate) {
          this.debouncedUpdate = this.debounce(() => {
            const currentValue = this.productInfoManager.getData()?.book?.[this.fieldName];
            let valueToSave = this.localValue;
            const isValid = this.validateValue(this.localValue);
            if (currentValue == valueToSave) {
              this.isUpdating = false;
              return;
            }
            
            if (isValid) {
              
              if (this.type === 'number') {
                if (valueToSave === '' || valueToSave === null || valueToSave === undefined) {
                  valueToSave = 0;
                }
              }
              
              if (currentValue !== valueToSave && this.saveImmediately) {
                this.hasError = false;
              }
              
              const options = { saveImmediately: this.saveImmediately };
              if (this.type === 'number') {
                options.valueType = 'number';
              }
              
              this.productInfoManager.updateField(`book.${this.fieldName}`, valueToSave, options);
            } else {
              this.isUpdating = false;
            }
          }, 800);
        }
        
        this.debouncedUpdate();
      }
    },
    
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    validateValue(value) {
      const rules = this.rules || this.processedRules || [];
      
      if (!rules || rules.length === 0) {
        return true;
      }
      
      for (const rule of rules) {
        if (typeof rule === 'function') {
          const result = rule(value);
          if (result !== true) {
            this.validationError = true;
            return false;
          }
        }
      }
      
      this.validationError = false;
      return true;
    },
    
    setupProductInfoListeners() {
      if (this.productInfoManager) {
        this.productInfoManager.on('field-saving', (data) => {
          if (data.fieldName === this.fieldName) {
            this.isUpdating = true;
            this.hasError = false;
          }
        });
        
        this.productInfoManager.on('field-saved', (data) => {
          if (data.fieldName === this.fieldName) {
            this.isUpdating = false;
            this.showSuccess = true;
            if (this.successTimeout) clearTimeout(this.successTimeout);
            this.successTimeout = setTimeout(() => {
              this.showSuccess = false;
            }, 2000);
          }
        });
        
        this.productInfoManager.on('field-error', (data) => {
          if (data.fieldName === this.fieldName) {
            this.isUpdating = false;
            this.hasError = true;
          }
        });
        
        this.productInfoManager.on('product-uploaded', () => {
          this.initializeFromBackend();
        });
        
        this.productInfoManager.on('field-save-cancelled', (data) => {
          if (data.fieldName === this.fieldName) {
            this.isUpdating = false;
          }
        });
      }
    }
  }
};